export const godPermission = "all"; // for mocks and admin admin

export const employeeAhrRolePermissionRead = "employee:ahrRole:read";
export const employeeAhrRolePermissionWrite = "employee:ahrRole:write";
export const employeeEmployeePermissionRead = "employee:employee:read";
export const employeeEmployeePermissionWrite = "employee:employee:write";
export const employeeDepartmentPermissionWrite = "employee:department:write";
export const employeeAccountPermissionWrite = "employee:account:write";
export const employeeAccountPermissionRead = "employee:account:read";
export const employeeEmployeeGroupPermissionRead =
  "employee:employeeGroup:read";
export const employeeEmployeeGroupPermissionWrite =
  "employee:employeeGroup:write";
export const employeeEmployeeLeavePermissionRead =
  "employee:employeeLeave:read";
export const employeeEmployeeLeavePermissionWrite =
  "employee:employeeLeave:write";
export const employeeOrganizationUnitPermissionRead =
  "employee:organizationUnit:read";
export const employeeOrganizationUnitPermissionWrite =
  "employee:organizationUnit:write";
export const employeeRentableGroupPermissionRead =
  "employee:rentableGroup:read";
export const employeeRentableGroupPermissionWrite =
  "employee:rentableGroup:write";
export const employeeRentableGroupSelectionWindowPermissionRead =
  "employee:rentableGroupSelectionWindow:read";
export const employeeRentableGroupSelectionWindowPermissionWrite =
  "employee:rentableGroupSelectionWindow:write";
export const employeeEmployeePermissionClearRentableGroup =
  "employee:employee:clear-rentable-group";
export const ssoIpAddressRestrictionPermissionRead =
  "sso:ipAddressRestriction:read";
export const ssoIpAddressRestrictionPermissionWrite =
  "sso:ipAddressRestriction:write";
export const ombTwoFactorLoginReset = "sso:omb:twoFactorLoginReset";
export const ssoCanSwitchUser = "sso:canSwitchUser";
export const ssoPasswordChangeWrite = "sso:passwordChange:write";
export const companyApplicationPermissionRead = "company:application:read";
export const companyApplicationPermissionWrite = "company:application:write";
export const companyAttachmentPermissionRead = "company:attachment:read";
export const companyAttachmentPermissionWrite = "company:attachment:write";
export const companyCompanyPermissionRead = "company:company:read";
export const companyCompanyPermissionWrite = "company:company:write";
export const companyTokenPermissionRead = "company:token:read";
export const companyTokenPermissionWrite = "company:token:write";
export const companyReportAccessPasswordRead =
  "company:reportAccessPassword:read";
export const companyMediaPermissionWrite = "company:mediaObject:write";
export const companySingleChargesWrite = "company:singleCharges:write";
export const operatorOperatorPermissionRead = "operator:operator:read";
export const operatorOperatorPermissionWrite = "operator:operator:write";
export const operatorDiagnosticPermissionRead = "operator:diagnostic:read";
export const tourismTourismObjectPermissionRead = "tourism:tourismObject:read";
export const tourismTourismObjectPermissionWrite =
  "tourism:tourismObject:write";
export const tourismTourismObjectPermissionImport =
  "tourism:tourismObject:import";
export const tourismTourismPicturePermissionWrite =
  "tourism:tourismPicture:write";
export const tourismTourismAttributePermissionRead =
  "tourism:tourismAttribute:read";
export const tourismTourismAttributePermissionDelete =
  "tourism:tourismAttribute:delete";
export const tourismTourismAttributePermissionWrite =
  "tourism:tourismAttribute:write";
export const tourismTourismAttributeOptionPermissionRead =
  "tourism:tourismAttributeOption:read";
export const tourismTourismAttributeOptionPermissionWrite =
  "tourism:tourismAttributeOption:write";
export const tourismTourismObjectChangelogPermissionRead =
  "tourism:tourismObjectChangelog:read";
export const tourismTourismObjectImportAnixePermissionRead =
  "tourism:tourismObjectImportAnixe:read";
export const tourismMediaPermissionWrite = "tourism:mediaObject:write";
export const tourismAttachmentPermissionRead = "tourism:attachment:read";
export const tourismAttachmentPermissionWrite = "tourism:attachment:write";
export const cmsDocumentPermissionRead = "cms:document:read";
export const cmsDocumentPermissionWrite = "cms:document:write";
export const translationTranslatePermissionWrite =
  "translation:translation:write";
export const translationTranslationScopePermissionRead =
  "translation:translationScope:read";
export const translationTranslationScopePermissionWrite =
  "translation:translationScope:write";
export const configurationConfigurationPermissionRead =
  "configuration:configuration:read";
export const configurationConfigurationPermissionWrite =
  "configuration:configuration:write";
export const configurationMediaWrite = "configuration:mediaObject:write";
export const notificationEmailPermissionWrite = "notification:email:write";
export const notificationEmailPermissionRead = "notification:email:read";
export const notificationPushMessagePermissionWrite =
  "notification:pushMessage:write";
export const notificationPushMessagePermissionRead =
  "notification:pushMessage:read";
export const notificationAppMessagePermissionWrite =
  "notification:appMessage:write";
export const notificationAppMessagePermissionRead =
  "notification:appMessage:read";
export const notificationSmsPermissionCreate = "notification:sms:create";
export const notificationSmsPermissionRead = "notification:sms:read";
export const notificationMediaPermissionWrite =
  "notification:mediaObject:write";
export const catalogProductPermissionRead = "catalogManagement:product:read";
export const catalogProductPermissionWrite = "catalogManagement:product:write";
export const catalogProductAttachmentPermissionRead =
  "catalogManagement:attachment:read";
export const catalogProductAttachmentPermissionWrite =
  "catalogManagement:attachment:write";
export const catalogProductAttachmentFilePermissionRead =
  "catalogManagement:attachmentFile:read";
export const catalogProductAttachmentFilePermissionWrite =
  "catalogManagement:attachmentFile:write";
export const catalogProductCodeTemplatePermissionRead =
  "catalogManagement:codeTemplate:read";
export const catalogProductCodeTemplatePermissionWrite =
  "catalogManagement:codeTemplate:write";
export const catalogManagementInactiveEmployeeCodesWrite =
  "catalogManagement:inactiveEmployeeCodes:write";
export const catalogCategoryPermissionRead =
  "catalogManagement:businessCategory:read";
export const catalogCategoryPermissionWrite =
  "catalogManagement:businessCategory:write";
export const catalogMediaPermissionWrite =
  "catalogManagement:mediaObject:write";
export const dictionaryDictionaryPermissionRead = "dictionary:dictionary:read";
export const dictionaryDictionaryPermissionWrite =
  "dictionary:dictionary:write";
export const dictionaryDictionaryItemsImportWrite =
  "dictionary:dictionaryItemsImport:write";
export const agreementAgreementPermissionRead = "agreement:agreement:read";
export const agreementAgreementPermissionWrite = "agreement:agreement:write";
export const agreementMediaPermissionWrite = "agreement:mediaObject:write";
export const subscriptionBenefitCategoryPermissionRead =
  "subscriptionManagement:benefitCategory:read";
export const subscriptionBenefitCategoryPermissionWrite =
  "subscriptionManagement:benefitCategory:write";
export const subscriptionBenefitPermissionRead =
  "subscriptionManagement:benefit:read";
export const subscriptionBenefitPermissionWrite =
  "subscriptionManagement:benefit:write";
export const subscriptionBenefitGroupPermissionRead =
  "subscriptionManagement:benefitGroup:read";
export const subscriptionBenefitGroupPermissionWrite =
  "subscriptionManagement:benefitGroup:write";
export const subscriptionBenefitGroupAttachmentPermissionWrite =
  "subscriptionManagement:benefitGroupAttachment:write";
export const subscriptionBenefitGroupAttachmentPermissionDelete =
  "subscriptionManagement:benefitGroupAttachment:delete";
export const subscriptionActiveFormPermissionRead =
  "subscriptionManagement:activeForm:read";
export const subscriptionActiveFormGroupPermissionWrite =
  "subscriptionManagement:activeForm:write";
export const subscriptionAttachmentPermissionRead =
  "subscriptionManagement:attachment:read";
export const subscriptionAttachmentPermissionWrite =
  "subscriptionManagement:attachment:write";
export const subscriptionEmployeeSubscriptionItemRead =
  "subscriptionManagement:employeeSubscriptionItem:read";
export const subscriptionEmployeeSubscriptionItemBlockade =
  "subscriptionManagement:employeeSubscriptionItem:blockade";
export const subscriptionEmployeeSubscriptionItemChangeDates =
  "subscriptionManagement:employeeSubscriptionItem:changeDates";
export const subscriptionEmployeeSubscriptionItemResign =
  "subscriptionManagement:employeeSubscriptionItem:resign";
export const subscriptionEmployeeSubscriptionItemCancel =
  "subscriptionManagement:employeeSubscriptionItem:cancel";
export const subscriptionEmployeeSubscriptionItemCancelAhr =
  "subscriptionManagement:employeeSubscriptionItem:cancelAhr";
export const subscriptionEmployeeSubscriptionItemAccept =
  "subscriptionManagement:employeeSubscriptionItem:accept";
export const subscriptionEmployeeSubscriptionItemUpdateForm =
  "subscriptionManagement:employeeSubscriptionItem:updateForm";
export const subscriptionEmployeeSubscriptionItemUpdatePersonalData =
  "subscriptionManagement:employeeSubscriptionItem:updatePersonalData";
export const subscriptionEmployeeSubscriptionItemGeneratePdf =
  "subscriptionManagement:employeeSubscriptionItem:generatePdf";
export const subscriptionPdfFormPermissionRead =
  "subscriptionManagement:pdfForm:read";
export const subscriptionPdfFormPermissionWrite =
  "subscriptionManagement:pdfForm:write";
export const subscriptionBenefitEmployeeGroupPermissionRead =
  "subscriptionManagement:benefitEmployeeGroup:read";
export const subscriptionBenefitEmployeeGroupPermissionWrite =
  "subscriptionManagement:benefitEmployeeGroup:write";
export const subscriptionMediaPermissionWrite =
  "subscriptionManagement:mediaObject:write";
export const subscriptionManagementConfigurationStatusWrite =
  "subscriptionManagement:configurationStatus:write";
export const banksBanksPermissionRead = "company:pointsBank:read";
export const banksBanksPermissionWrite = "company:pointsBank:write";
export const employeeGroupProductConfigPermissionRead =
  "employeeGroupProduct:employeeGroupProductData:read";
export const employeeGroupProductConfigPermissionWrite =
  "employeeGroupProduct:employeeGroupProductData:write";
export const employeeGroupProductTemplatePermissionWrite =
  "employeeGroupProduct:egpTemplate:write";
export const magentoAdminOrderPermissionRead = "magentoAdmin:order:read";
export const magentoAdminOrderPermissionTransactionUpdate =
  "magentoAdmin:orderTransaction:update";
export const magentoAdminOrderCodePermissionRead = "magentoAdmin:code:read";
export const magentoECommercePermissionAccess = "e-commerce:magento";
export const employeeMultisportCardAdministrator =
  "employee:multisportCardAdministrator";
export const companyMultisportCardWaitingRoom =
  "company:multisportCardWaitingRoom";
export const companySubscriptionsWaitingRoom =
  "company:subscriptionsWaitingRoom";
export const companyAccessToSportsCards = "company:accessToSportsCards";
export const companyMyBenefitActiveRead = "company:myBenefitActive:read";
export const companyPrepaidCardRead = "company:prepaidCard:read";
export const companyPrepaidCardWrite = "company:prepaidCard:write";
export const cyclicChargesPermissionWrite = "employee:accountCharges:write";
export const cyclicChargesPermissionAccept =
  "employee:accountCharges:acceptance";
export const proposalsModulePermissionRead = "proposals:proposals:read";

export const totalRewardModule = "totalRewardStatement:module:read";
export const totalRewardSettings = "totalRewardStatement:settings:write";
export const totalRewardPerkUsersImportExport =
  "totalRewardStatement:perkUser:importexport";
export const totalRewardPerkUsersRead = "totalRewardStatement:perkUser:read";
export const totalRewardPerkUsersWrite = "totalRewardStatement:perkUser:write";
export const totalRewardPerksRead = "totalRewardStatement:perk:read";
export const totalRewardPerksWrite = "totalRewardStatement:perk:write";
export const totalRewardPerksAutomationWrite =
  "totalRewardStatement:automation:write";
export const totalRewardPerkCategoriesRead =
  "totalRewardStatement:perkCategory:read";
export const totalRewardPerkCategoriesWrite =
  "totalRewardStatement:perkCategory:write";
export const payrollRoleAdmin = "payroll:role:admin";
export const payrollRoleUnitAdmin = "payroll:role:unitAdmin";

// BELOW REPORTS PERMISSIONS
export const reportsAhrGraphs = "chart:chart001:read";

export const reportsEmp0001 = "report:emp0001:read";
export const reportsEmp0002 = "report:emp0002:read";
export const reportsEmp0003 = "report:emp0003:read";
export const reportsEmp0004 = "report:emp0004:read";
export const reportsEmp0005 = "report:emp0005:read";
export const reportsCli0002 = "report:cli0002:read";
export const reportsCli0003 = "report:cli0003:read";
export const reportsCli0014 = "report:cli0014:read";
export const reportsCli0015 = "report:cli0015:read";
export const reportsCli0016 = "report:cli0016:read";
export const reportsCli0017 = "report:cli0017:read";
export const reportsCli0019 = "report:cli0019:read";
export const reportsEmp0007 = "report:emp0007:read";
export const reportsCli0018 = "report:cli0018:read";
export const reportsCli0022 = "report:cli0022:read";
export const reportsCli0033 = "report:cli0033:read";
export const reportsCli0035 = "report:cli0035:read";
export const reportsCli0037 = "report:cli0037:read";
export const reportsCli0036 = "report:cli0036:read";
export const reportsCli0034 = "report:cli0034:read";
export const reportsCli0038 = "report:cli0038:read";
export const reportsCli0039 = "report:cli0039:read";
export const reportsCli0043 = "report:cli0043:read";
export const reportsCli0048 = "report:cli0048:read";
export const reportsCli0040 = "report:cli0040:read";
export const reportsCli0042 = "report:cli0042:read";
export const reportsCli0041 = "report:cli0041:read";
export const reportsCli0045 = "report:cli0045:read";
export const reportsEmp0006 = "report:emp0006:read";
export const reportsCli0049 = "report:cli0049:read";
export const reportsCli0050 = "report:cli0050:read";
export const reportsCli0003Old = "report:cli0003_old:read";
export const reportsCli0003New = "report:cli0003_new:read";
export const reportsEmp0008 = "report:emp0008:read";

// REPORTS EXTRA
const reportExtraCli0003Old = "reportExtra:cli0003_old:read";
const reportExtraCli0003New = "reportExtra:cli0003_new:read";
const reportExtraCli0002 = "reportExtra:cli0002:forceOmb";

// ABSENCES REPORTS
export const reportAbsentsCli0051 = "reportAbsents:cli0051:read";
export const reportAbsentsCli0052 = "reportAbsents:cli0052:read";
export const reportAbsentsCli0053 = "reportAbsents:cli0053:read";

export const REPORTS_PERMISSIONS_ALL = [
  reportsAhrGraphs,
  reportsEmp0001,
  reportsEmp0002,
  reportsEmp0003,
  reportsEmp0004,
  reportsEmp0005,
  reportsCli0002,
  reportsCli0003,
  reportsCli0014,
  reportsCli0015,
  reportsCli0016,
  reportsCli0017,
  reportsCli0019,
  reportsEmp0007,
  reportsCli0018,
  reportsCli0022,
  reportsCli0033,
  reportsCli0035,
  reportsCli0037,
  reportsCli0036,
  reportsCli0034,
  reportsCli0038,
  reportsCli0039,
  reportsCli0043,
  reportsCli0048,
  reportsCli0040,
  reportsCli0042,
  reportsCli0041,
  reportsCli0045,
  reportsEmp0006,
  reportsCli0049,
  reportsCli0050,
  reportsCli0003Old,
  reportsCli0003New,
  reportsEmp0008,
  reportExtraCli0003Old,
  reportExtraCli0003New,
  reportExtraCli0002,
  reportAbsentsCli0051,
  reportAbsentsCli0052,
  reportAbsentsCli0053,
];

// BELOW ARE NOT CONFIRMED PERMISSIONS (WAITING FOR BACKEND
export const companyFundingPermissionRead = "company:funding:read";
export const companyFundingPermissionWrite = "company:funding:write";
export const jobManagerProcessRead = "jobManager:process:read";
export const jobManagerProcessOutputRead = "jobManager:processOutput:read";

export const employeeSftpImportRead = "sftp:employeeSFTPImport:read";
export const employeeSftpImportWrite = "sftp:employeeSFTPImport:write";

// BELOW ORGANIZATION STRUCTURE PERMISSIONS
export const organizationStructureModuleRead =
  "organizationStructure:module:read";
export const organizationStructureStructureCreate =
  "organizationStructure:structure:create";
export const organizationStructureStructureEdit =
  "organizationStructure:structure:edit";
export const organizationStructureStructureEnable =
  "organizationStructure:structure:enable";
export const organizationStructureStructureDelete =
  "organizationStructure:structure:delete";
export const organizationStructureAreaAdd = "organizationStructure:area:add";
export const organizationStructureAreaEdit = "organizationStructure:area:edit";
export const organizationStructureAreaDelete =
  "organizationStructure:area:delete";
export const organizationStructureAreaImport =
  "organizationStructure:area:import";
export const organizationStructureAreaExport =
  "organizationStructure:area:export";
export const organizationStructureAreaRead =
  "organizationStructure:areaimporthistory:read";
export const organizationStructureEmployeeDataImport =
  "organizationStructure:employeedata:import";
export const organizationStructureEmployeeDataExport =
  "organizationStructure:employeedata:export";
export const organizationStructureEmployeeDataRead =
  "organizationStructure:employeedataimporthistory:read";

export const organizationStructureOrganizationStructureTabView =
  "organizationStructure:organizationstructuretab:view";
export const organizationStructureOrganizationStructureTabEdit =
  "organizationStructure:organizationstructuretab:edit";
export const organizationStructureEmploymentTabView =
  "organizationStructure:employmenttab:view";
export const organizationStructureEmploymentTabEdit =
  "organizationStructure:employmenttab:edit";

// MODUŁ NIEOBECNOŚCI
export const absencesModuleRead = "absences:module:read"; // Dostęp do modułu
export const absencesAbsenceRequestsRead = "absences:absenceRequests:read"; // Podgląd wszystkich wniosków
export const absencesApprovableAbsenceRequestsEdit =
  "absences:approvableAbsenceRequests:edit"; // Edycja i anulacja wniosków, których jest akceptantem
export const absencesAbsenceRequestsEdit = "absences:absenceRequests:edit"; // Edycja i anulacja wszystkich wniosków // dla OMB
export const absencesOtherEmployeeAbsenceRequestsCreate =
  "absences:otherEmployeeAbsenceRequests:create"; // Możliwość składania wniosków w imieniu pracownika
export const absencesAbsenceRequestsApprover =
  "absences:absenceRequests:approver"; // Widoczność na liście akceptantów wniosków w module nieobecności
export const absencesEmployeeAbsenceRecordsRead =
  "absences:employeeAbsenceRecords:read"; // Podgląd "Kartotek nieobecności pracowników"
export const absencesEmployeeAbsenceRecordsWrite =
  "absences:employeeAbsenceRecords:write"; // Edycja i importy w "Kartotekach nieobecności pracowników"
export const absencesAbsencesConfigurationRead =
  "absences:absencesConfiguration:read"; // Podgląd sekcji "Konfiguracja nieobecności"
export const absencesAbsencesConfigurationWrite =
  "absences:absencesConfiguration:write"; // Dokonywanie zmian w sekcji "Konfiguracja nieobecności"
export const absencesAbsencesConfigurationCustomFields =
  "absences:absencesConfiguration:customFields"; // Możliwość dodawania pól konfigurowalnych na wniosku
export const absencesEmployeeCardFullAbsenceInfo =
  "absences:employeeCard:fullAbsenceInfo"; // Wyświetlanie pełnych informacji o rodzajach nieobecności w karcie pracownika (SO)
export const absencesAbsenceRequestsImport =
  "absences:absencesConfiguration:absenceRequestsImport"; // Import wniosków z innego narzędzia

// RAPORTY NIEOBECNOŚCI
export const absencesReportsAbsenceRequestsReportRead =
  "absencesReports:absenceRequestsReport:read";
export const absencesReportsAvailableAbsenceQuotasReportRead =
  "absencesReports:availableAbsenceQuotasReport:read";
export const absencesReportsUsedAbsenceQuotasReportRead =
  "absencesReports:usedAbsenceQuotasReport:read";
export const absencesReportsImportCalendarsReportRead =
  "absencesReports:importCalendarsReport:read";
export const absencesReportsImportPatternsQuotasReportRead =
  "absencesReports:importPatternsQuotasReport:read";

// WALL
export const wallModuleWrite = "wall:module:write"; // Zarządzanie modułem aktualności

// KNOWLEDGE BASE
export const knowledgeBaseModuleWrite = "knowledgeBase:module:write"; // Zarządzanie modułem bazy wiedzy
